import { useState } from "react";

/**
 * The add / edit and delete dialogs of a database page: which row each is
 * open on, the add-or-edit mode, and the form, filled from the row on edit
 * and reset to `emptyForm` on add and on close.
 */
export function useRowDialogs<TItem, TForm>(emptyForm: TForm, toForm: (item: TItem) => TForm) {
  const [editDialog, setEditDialog] = useState<{ open: boolean; item: TItem | null }>({ open: false, item: null });
  const [deleteDialog, setDeleteDialog] = useState<{ open: boolean; item: TItem | null }>({ open: false, item: null });
  const [formData, setFormData] = useState<TForm>(emptyForm);
  const [isAddMode, setIsAddMode] = useState(false);

  const openEdit = (item: TItem | null) => {
    setIsAddMode(!item);
    setFormData(item ? toForm(item) : emptyForm);
    setEditDialog({ open: true, item });
  };

  const closeEdit = () => {
    setEditDialog({ open: false, item: null });
    setFormData(emptyForm);
    setIsAddMode(false);
  };

  const openDelete = (item: TItem) => setDeleteDialog({ open: true, item });
  const closeDelete = () => setDeleteDialog({ open: false, item: null });

  return { editDialog, deleteDialog, formData, setFormData, isAddMode, openEdit, closeEdit, openDelete, closeDelete };
}
